import { render } from "./RelatorioComponent.vue?vue&type=template&id=6a08bf14&ts=true"
import script from "./RelatorioComponent.vue?vue&type=script&lang=ts"
export * from "./RelatorioComponent.vue?vue&type=script&lang=ts"

import "./RelatorioComponent.vue?vue&type=style&index=0&id=6a08bf14&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__